// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15dLt","field":"styles_field__3rJQA","fieldCol":"styles_fieldCol__NgcDJ","diffCol":"styles_diffCol__1k422","diff":"styles_diff__2AIrJ"};